export default "__VITE_ASSET__Df5TzFV3__"